/**
 *
 */
'use strict';

angular.module('betosyswebapp').directive('shortcut', function () {
  return {
    restrict: 'E',
    transclude: true,
    link: function (scope) {
      var ctrlDown = false,
        ctrlKey = 17,
        cmdKey = 91,
        cKey = 67;
      scope.$on('$destroy', function () {

        $(document).unbind('click', documentClickEventHandler);
      });
      /**
       * client event handler which listens to document click .
       *
       * currently it listens the regions of telephone columns using the class names 'telephnoe-overview-btn' , 'overview-popup-telephn-input'
       *
       * @param {*} event
       */
      function documentClickEventHandler(event) {
        //console.log('click')
        if (!$(event.target).hasClass('overview-popup-telephn-input') && !$(event.target).hasClass('telephnoe-overview-btn') || $(event.target).hasClass('overview-popup-telephn-input')) {
          removeTelephonePopupElement();
        } else if ($(event.target).hasClass('telephnoe-overview-btn')) {

          var elHtml =
            '<div id="overview-telephn-popup-container" class="overview-telephn-popup-container">' +
            '<input id="overview-telephn-popup-input" class="overview-popup-telephn-input" type="text"  value="' + convertToPopupFormat($(event.target).val()) + '" readonly>' +
            '</input>' +
            '</div>';
          removeTelephonePopupElement();
          $(event.target).after(elHtml);
          $('#overview-telephn-popup-input').keydown(function (e) {
            if (e.keyCode === ctrlKey || e.keyCode === cmdKey) {
              ctrlDown = true;
            }
            if (ctrlDown && (e.keyCode === cKey)) {
              e.preventDefault();
              e.stopPropagation();
              $('#overview-telephn-popup-input').select();
              document.execCommand('copy');
              //console.log('Ctrl+c');
            }
          }).keyup(function (e) {
            if (e.keyCode === ctrlKey || e.keyCode === cmdKey) {
              ctrlDown = false;
            }
          });
          setTimeout(function () {
            $('#overview-telephn-popup-input').select();
          }, 10);
        }
      }

      $(document).on('click', documentClickEventHandler);


      /**
       * removed unwanted characters from phone number text .
       * replace '+' with '00' prefix.
       *
       * @param {*} phoneNumber
       */
      function convertToPopupFormat(phoneNumber) {
        //ignore if null
        if (phoneNumber === undefined || phoneNumber === null || phoneNumber === '') {
          return '';
        }
        var temp = phoneNumber;
        temp = temp.replace(/\+/g, '00'); // replace '+' with '00'
        return temp;
      }
      /**
       * Removes the dynamically added dom elements for telephone formatting pop up.
       */
      function removeTelephonePopupElement() {
        $('overview-telephn-popup-input').unbind();
        $('.overview-telephn-popup-container').unbind();
        $('.overview-telephn-popup-container').remove();
      }

    }
  };
});



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/shortcut.js